export const DOMAIN = 'https://nejmqianyan.cn';
export const API_PATH = DOMAIN + '/nejm-api';
export const API_PATH_PHP = DOMAIN + '/index.php';
